import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const init = () => ({
  type: types.INIT,
});

export const startShare = config => ({
  type: types.START_SHARE,
  config,
});

const { init: initRequest, fetching } = createAllActions(types.SCOPE);

export { initRequest, fetching };
